// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'

import 'babel-polyfill'

import FastClick from 'fastclick'

import 'lib-flexible/flexible.js'

import './../src/assets/css/reset.css'
import './../src/assets/css/common.css'

// 添加SDK资源

// (function () {
//   document.title = '夏季涨薪招聘会';
//   var wb = document.createElement('script'),
//     s = document.getElementsByTagName('script')[0],
//     url = 'a.58cdn.com.cn/app58/rms/app/js/app_30805.js?';
//   wb.type = 'text/javascript';
//   wb.async = false;
//   wb.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + url + (+new Date());
//   s.parentNode.insertBefore(wb, s);
// })();

document.title = '人才直通计';
FastClick.attach(document.body);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js